import { ElementId, Track } from '@/services/track'
import { attr, html, on, TNode } from '@tempots/dom'

export type InlineLinksOptions = {
  links: { href: string; label: TNode; element_id: ElementId }[]
}

export function InlineLinks({ links }: InlineLinksOptions) {
  return html.ul(
    attr.class(
      'flex flex-wrap gap-2 sm:gap-0 sm:space-x-4 text-sm sm:text-base'
    ),
    links.map(link =>
      html.li(
        html.a(
          attr.href(link.href),
          attr.class('whitespace-nowrap'),
          on.click(() =>
            Track.click({
              section: 'top_bar',
              element_type: 'link',
              click_action: 'navigate',
              element_id: link.element_id,
            })
          ),
          link.label
        )
      )
    )
  )
}
